import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import React from 'react'
import { WizTableForm } from '../../../common'
import moment from "moment";

//配置项
let componentName = 'requirementNoticeRecord'

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "通知人",
    name: "notifierStr",
    dataIndex: "notifierStr",
    tableItem: { width: 150 },
  },
  {
    title: "通知时间",
    name: "noticeTime",
    dataIndex: "noticeTime",
    // tableItem: { width: 300 },
    tableItem: {
      render: (text, record) => {
        return formatterMinute(text)
      }
    },
  },
  {
    title: "通知类型",
    name: "noticeTypeStr",
    dataIndex: "noticeTypeStr",
    tableItem: {},
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      //btnAccessCheck: false,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        collapse: false,
        buttonSort: ['export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        // selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      // showAuth: {
      //   title: '适用范围',
      //   dataIndex: 'authData'
      // },
      rowOperateSort: ['download'],
      rowOperateView: [
        {
          key: "download",
          custom: true,
          params: { children: "下载" },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "download",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let url = getOssFilePath(record.mailFileId + "?preview=false")
              window.open(url);
              //  return null
            }
          },
          recordChangeParams: (record, rows) => {
            let disabled = true;
            if (record && record.record && record.record.mailFileId) {
              disabled = false;
            }
            return { disabled }
          },

        },
        // {
        //   key: "download",
        //   name: "WizButton",
        //   params: { children: "下载" },
        //   onClick: ({ record }) => {
        //     let url = getOssFilePath(record.mailFileId+"?preview=false")
        //     window.open(url);
        //   },
        //   recordChangeParams: (record, rows) => {
        //     console.log("record==11",record);
        //     let result = { disabled: true, hidden: true };

        //     return result
        //   },
        // }
      ],
      commonOperate: {
        add: true,
        update: true
      }
    }
  }
};

const apis = (noticeId) => {
  return {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, noticeId }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { noticeId }
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  const { noticeId } = args;
  return {
    apis: apis(noticeId),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
